<template>
    <div>
        <div class="banner" data-aos="zoom-out"><img :src="require('@/assets/img/about/position/banner.png')" ></div>
        <div class="container">
            <about-menu @aboutSelect="aboutSelect"></about-menu>
            <div>
                <div class="title" data-aos="fade-up">热招职位</div>
                <div class="position">
                    <div class="content" v-for="item in positionList" data-aos="fade-up">
                        <div class="name">{{item.name}} [{{item.address}}]</div>
                        <div class="request">
                            <span class="salary">{{item.salary}}</span>
                            <span class="experience">{{item.experience}}</span>
                            <span class="experience education">{{item.education}}</span>
                        </div>
                        <a class="link" target="_blank" href="https://www.zhipin.com/gongsir/a41610191f4ed8ff1HNz3Nq9GQ~~.html?ka=all-jobs-hot">立即查看<i class="el-icon-arrow-right"></i></a>
                    </div>
                </div>
                <div class="welfare">
                    <img :src="require('@/assets/img/about/position/welfare.png')" style="width: 100%" data-aos="zoom-in">
                </div>
            </div>
         </div>
    </div>
</template>

<script>
import AboutMenu from "../../components/AboutMenu";
export default {
    components: {
	    AboutMenu
    },
    data() {
        return {
            positionList:[
                {
                    name:'实施项目经理',
                    address:'上海',
                    salary:'18-25K',
                    experience:'3-5年',
                    education:'本科'
                },
                {
                    name:'中级产品经理',
                    address:'湖州',
                    salary:'10-13K',
                    experience:'3-5年',
                    education:'大专'
                },
                {
                    name:'医疗软件实施工程师',
                    address:'上海',
                    salary:'15-20K·13薪',
                    experience:'5-10年',
                    education:'本科'
                },
                {
                    name:'软件实施工程师',
                    address:'湖州',
                    salary:'11-20K',
                    experience:'5-10年',
                    education:'大专'
                }
            ],
        }
    },
    methods:{
        aboutSelect(src){
	        this.$emit('aboutSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
    .banner{
        width: 100%;
    }
    .container{
        width: 100%;
        padding-left: 20%;
        box-sizing: border-box;
        position: relative;
    }
    .title{
        width: 175px;
        height: 74px;
        margin: 68px auto;
        background: url("../../assets/img/about/position/title.png") no-repeat;
        text-align-last:justify;
        text-align: justify;
        font-size: 36px;
        color: #ed1d25;
    }
    .position{
        .content{
            width: 992px;
            height: 124px;
            padding: 36px 93px;
            margin: 0 auto 12px;
            box-sizing: border-box;
            border-radius: 10px;
            box-shadow: 0 0 10px #dedede;
            position: relative;
            .name{
                font-size: 16px;
                color: #383838;
                margin-bottom: 16px;
            }
            .request{
                font-size: 14px;
                .salary{
                    color: #fe6457;
                    letter-spacing: 1px;
                }
                .experience{
                    display: inline-block;
                    padding: 5px;
                    color: #808080;
                    background: #f7f7f7;
                    border-radius: 5px;
                    margin: 0 8px;
                }
                .education{
                    margin: 0;
                }
            }
            .link{
                font-family: SourceHanSansCN-Normal;
                position: absolute;
                bottom: 8px;
                right: 54px;
                color: #000;
                font-size: 17px;
                text-decoration: none;
                height: 28px;
                line-height: 18px;
                letter-spacing: 1px;
                box-sizing: border-box;
                &:hover{
                    color: #006efd;
                    border-bottom: 2px solid #006efd;
                    i{
                        color: #006efd;
                    }
                }
            }
        }
    }
    .welfare{
        margin: 42px 0 115px 0;
    }
</style>
